/**
 * isDirty
 *
 * Returns true when `current` differs from `baseline`. Used to gate Save
 * buttons on forms so Save only enables once the user has actually changed
 * something — not just whenever the form isn't currently submitting.
 *
 * Deep comparison via JSON.stringify. Caveat: this is sensitive to object key
 * insertion order. Safe for the call sites this is used at because `current`
 * is always built by spreading over the same-shaped object `baseline` was
 * captured from (object spread preserves existing key order), so both sides
 * are constructed consistently.
 *
 * @param {*} current  - The live/edited value.
 * @param {*} baseline - The snapshot to compare against (loaded-from-server
 *   value, or the value most recently saved).
 * @returns {boolean}
 */
export function isDirty(current, baseline) {
  return JSON.stringify(current) !== JSON.stringify(baseline);
}

export default isDirty;
